import styled, { keyframes } from 'styled-components';

const scaleIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const cubicBezier = `cubic-bezier(0.34, 1.56, 0.64, 1)`;

const duration = '300ms';

export const ScaleIn = styled('div')`
  animation: ${scaleIn} 700ms ${cubicBezier} forwards;
`;

export const FadeInFront = styled('div')`
  animation: ${fadeIn} ${duration} linear forwards;
`;

export const FadeInBack = styled('div')`
  animation: ${fadeIn} ${duration} linear forwards;
`;

export const InfoButton = styled('button')`
  width: ${({ theme }) => theme.x5}px;
  height: ${({ theme }) => theme.x5}px;
  border-radius: ${({ theme }) => theme.x5}px;
  background-color: ${({ theme }) => theme.color.whiteRGBA(0.1)};
  box-shadow: ${({ theme }) => theme.color.whiteRGBA(0.1)} 0px 0px 0px 1px inset;
`;

export const BackgroundImage = styled('img')`
  object-fit: cover;
  height: 100%;
  width: 100%;
  position: absolute;
  border-radius: ${({ theme }) => theme.x1}px;
  opacity: 0.1;
`;
